import { RcClasses } from '../../../../foundation';
export var RcDialogTitleClasses = RcClasses([], 'RcDialogTitle');
export var RcDialogTitleSpacings = {
    small: [4],
    medium: [4, 6],
};
export var RcDialogTitleTypographyVariant = {
    small: 'subheading2',
    medium: 'title2',
};
